import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_AVAILABLE_PAYMENT_SYSTEMS_ROUTE_NAME = Symbol('admin.settings.payment-systems');
export const ADMIN_AVAILABLE_PAYMENT_SYSTEMS_LIST_ROUTE_NAME = Symbol('admin.settings.payment-systems.list');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_PAYMENT_SYSTEMS = Symbol('general-settings.payment-systems');

export const SETTINGS_PAYMENT_SYSTEMS_LIST_URL = 'admin/payment_system_lists/allowed_payment_systems';
export const SETTINGS_PAYMENT_SYSTEMS_ADD_URL = 'admin/payment_system_lists/add_payment_system';
export const SETTINGS_PAYMENT_SYSTEMS_REMOVE_URL = 'admin/payment_system_lists/remove_payment_system';

export const SETTINGS_PAYMENT_SYSTEMS_LIST_QUERY_KEY = 'available-payment-systems.list';
export const SETTINGS_PAYMENT_SYSTEMS_ADD_MUTATION_KEY = 'available-payment-systems.add';
export const SETTINGS_PAYMENT_SYSTEMS_REMOVE_MUTATION_KEY = 'available-payment-systems.remove';

export const ADMIN_PAYMENT_SYSTEMS_PERMISSIONS = {
  PAYMENTSYSTEMLISTS_SHOW: new Permission(
    PermissionsList.admin.PAYMENTSYSTEMLISTS_SHOW,
  ),
  PAYMENTSYSTEMLISTS_UPDATE: new Permission(
    PermissionsList.admin.PAYMENTSYSTEMLISTS_UPDATE,
  ),
};
